var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2023_77738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.65548 6.43408H0.640452C0.462258 6.43408 0.317871 6.57853 0.317871 6.75666V19.6552C0.317871 19.8334 0.462258 19.9778 0.640452 19.9778H4.65548C4.83368 19.9778 4.97806 19.8334 4.97806 19.6552V6.75666C4.97806 6.57853 4.83368 6.43408 4.65548 6.43408Z",
    fill: "#2A374E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64942 0.0219727C1.18852 0.0219727 0 1.2092 0 2.66849C0 4.12842 1.18852 5.3161 2.64942 5.3161C4.10916 5.3161 5.29671 4.12836 5.29671 2.66849C5.29677 1.2092 4.10916 0.0219727 2.64942 0.0219727Z",
    fill: "#2A374E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.868 6.11353C13.2555 6.11353 12.0634 6.80675 11.3404 7.59443V6.75669C11.3404 6.57856 11.196 6.43411 11.0178 6.43411H7.17268C6.99448 6.43411 6.8501 6.57856 6.8501 6.75669V19.6553C6.8501 19.8335 6.99448 19.9778 7.17268 19.9778H11.1789C11.3571 19.9778 11.5015 19.8335 11.5015 19.6553V13.2735C11.5015 11.1229 12.0856 10.2851 13.5847 10.2851C15.2174 10.2851 15.3471 11.6282 15.3471 13.3841V19.6553C15.3471 19.8335 15.4915 19.9779 15.6697 19.9779H19.6775C19.8556 19.9779 20 19.8335 20 19.6553V12.5802C20 9.38249 19.3903 6.11353 14.868 6.11353Z",
    fill: "#2A374E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2023_77738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9422f7b0edd41f3343a56988f2c3950c.svg";
export { ForwardRef as ReactComponent };